import { CONTACT_KEY_SEPARATOR } from '@this+that/models';

// Same composition as the backend's DynamoDB activityKey (buildActivityKey in
// apps/api/src/features/crm/utils/personKeys.ts), minus the zero-padding — this
// key is only used for identity/dedup/React key, never lexicographic sort. The
// React key, the prepend-dedup key, and the highlight key MUST all be this exact
// string, or the highlight silently disappears with no error and no log.
export function buildMessageActivityKey(
  createdAt: number,
  messageId: string,
): string {
  return `${createdAt}${CONTACT_KEY_SEPARATOR}${messageId}`;
}
